import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofFinishedListPage } from './proof-finished-list';

@NgModule({
    declarations: [
        ProofFinishedListPage,
    ],
    imports: [
        IonicPageModule.forChild(ProofFinishedListPage),
    ],
    exports: [
        ProofFinishedListPage
    ]
})
export class ProofFinishedListPageModule { }


// WEBPACK FOOTER //
// ./src/pages/proof-finished-list/proof-finished-list.module.ts